module.exports = __webpack_public_path__ + "r-v3/img/ico_device_video.76892e78.svg";